module.exports = __webpack_public_path__ + "static/media/topspot.b65f7a48.jpg";